<template>
  <div class="text-drawer" @click="doNext">
    <drawer style="height:45px">
      <div class="text">
        <span
          v-for="(word, w) in words"
          :key="word + w"
        ><i
            v-for="(char, c) in word"
            ref="char"
            :key="word + w + char + c"
          >{{ char }}</i>&nbsp;</span>
      </div>
      <div v-if="ready" class="cursor"></div>
    </drawer>
  </div>
</template>

<script>
import anime from 'animejs'
import Drawer from '@/components/Drawer.vue'

export default {
  name: 'TextDrawer',

  components: {
    Drawer
  },

  data () {
    return {
      text: '',
      next: undefined,
      ready: false
    }
  },

  computed: {
    words () {
      return this.text.split(' ')
    }
  },

  methods: {
    doNext () {
      if (this.ready && this.next) {
        this.next()
      }
    },

    showText (text, next) {
      this.ready = false

      this.$set(this, 'text', text)
      this.$set(this, 'next', next)

      this.$nextTick(() => {
        const chars = [ ...this.$refs.char ]

        anime.remove(chars)
        anime({
          targets: chars,
          easing: 'linear',
          opacity: 0,
          duration: 0
        }).finished.then(() => {
          const timeline = anime.timeline()
          const speed = 200

          chars.forEach((char) => {
            timeline.add({
              targets: char,
              easing: 'linear',
              opacity: 1,
              duration: speed * 0.1
            })
          })

          timeline.finished.then(() => {
            setTimeout(() => {
              this.ready = true
            }, 150)
          })
        })
      })
    }
  }
}
</script>

<style lang="sass">
@keyframes blink-animation
  0%
    transform: translateY(-2px)
  50%
    transform: translateY(2px)
  100%
    transform: translateY(-2px)

.text-drawer
  position: relative
  i
    opacity: 0
    font-style: normal
  .cursor
    width: 7px
    height: 7px
    right: 5px
    bottom: 18px
    z-index: 2
    position: absolute
    background: #cbcbcb
    animation: blink-animation 750ms infinite
</style>
